namespace $ {

	export class $shm_hitalama_map_widget_entity_table extends $giper_baza_entity.with({

		/** @deprecated Use Map (since table-widget is one-to-many) */
		Widget: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ),
		
		Map: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),

		Form_custom: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_form_custom ),
		Dataset: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_dataset ),

		Head: $giper_baza_atom_list,
		Head_method: $giper_baza_atom_text,

		Rows: $giper_baza_atom_list,
		Rows_method: $giper_baza_atom_text,
		Rows_limit: $giper_baza_atom_real,

		Col_widths: $giper_baza_atom_list, 
		/**
		 * 'date'|'any'|'file'.
		 * 'file' is a ref_str to hitalama_file
		 */
		Col_types: $giper_baza_atom_list,
		Col_custom_codes: $giper_baza_atom_dict,
		Col_relation_datasets: $giper_baza_atom_dict,
		Col_relation_display_fields: $giper_baza_atom_dict,
		Col_select_options: $giper_baza_atom_dict,
		Cols_hidden: $giper_baza_atom_list,
		Cols_order: $giper_baza_atom_list,
		Cols_pinned: $giper_baza_atom_list,

		Rows_checked: $giper_baza_atom_dict,

	}){

		@ $mol_mem
		map() {
			return this.Map()?.remote() ?? this.Widget()?.remote()?.map()!
		}

		@ $mol_mem
		form_custom() {
			return this.Dataset()?.remote() ?? this.Form_custom()?.remote()
		}

		@ $mol_mem
		table_head( next?: any ): readonly any[] {
			const custom = this.form_custom()
			if( custom ) return custom.field_names()

			const method = this.Head_method()?.val()
			if( !method ) return this.Head(next)?.val( next ) ?? []

			return this.map().execute( method, { [ '$' + 'next' ]: next, [ '$' + 'table' ]: this } )
		}
		
		@ $mol_mem
		table_rows( next?: any ): readonly any[] {
			const custom = this.form_custom()
			if( custom ) {
				const head = this.table_head()
				return ( custom.objects() as readonly Record< string, any >[] ).map( obj => {
					return head.map( n => obj[n] )
				} ) ?? []
			}

			const method = this.Rows_method()?.val()
			if( !method ) return this.Rows(next)?.val( next ) ?? []

			const table = this
			return this.map().execute( method, { [ '$' + 'next' ]: next, [ '$' + 'table' ]: table } )
		}

		rows_limit( next?: number ) {
			const value = this.Rows_limit(next)?.val(next) ?? ( this.Dataset()?.remote() ? 50 : 1000 )
			return Math.max( 0, Math.floor( value ) )
		}

		rows_limited() {
			const rows = this.table_rows()
			const limit = this.rows_limit()
			if( limit <= 0 ) return rows
			return rows.slice( 0, limit )
		}

		static objects_to_table( arr: any[] ) {
			const keys = new Map< string, number >
			const rows: any[][] = []

			arr.forEach( obj => {
				const row: any[] = []
				rows.push( row )
				for( const key in obj ) {
					const index = keys.get( key ) ?? keys.size
					keys.set( key, index )
					row[ index ] = obj[ key ]
				}
			} )

			return { head: [ ...keys.keys() ], rows }
		}

		@ $mol_mem
		objects( next?: any[] ) {
			const custom = this.form_custom()
			if( custom ) return custom.objects()

			if( next ) {
				const { head, rows } = $shm_hitalama_map_widget_entity_table.objects_to_table( next )
				this.table_head( head )
				this.table_rows( rows )
				return next
			}

			const head = this.table_head()
			const rows = this.table_rows()
			return rows.map( r => Object.fromEntries( head.map( (h, i)=> [ h, r[i] ] ) ) )
		}
		
		@ $mol_mem
		table_data( next?: { head: string[], rows: any[][] } ) {
			if( next ) {
				this.table_head( next.head )
				this.table_rows( next.rows )
				return next
			}
			return {
				head: this.table_head(),
				rows: this.table_rows(),
			}
		}

		@ $mol_mem
		col_types( next?: any ) {
			const custom = this.form_custom()
			if( custom ) return custom.fields_parsed().arr.map( f => f.type )
			
			const types_raw = this.Col_types(next)?.val(next) ?? []

			const types = [ ...types_raw ] 

			this.table_head()?.forEach( ( title, i ) => {
				if( title == 'Дата' ) types[i] ??= 'date'
				types[i] ??= 'any'
			} )

			return types
		}

		@ $mol_mem
		col_custom_codes( next?: Record< string, string > ): Record< string, string > {
			return ( this.Col_custom_codes( next )?.val( next ) as Record< string, string > | undefined ) ?? {}
		}

		@ $mol_mem_key
		col_custom_code( name: string, next?: string ) {
			const codes = this.col_custom_codes()
			if( next === undefined ) return codes[ name ] ?? ''
			this.col_custom_codes({ ...codes, [ name ]: next })
			return next
		}

		@ $mol_mem_key
		col_relation_dataset( name: string, next?: string ) {
			const links = ( this.Col_relation_datasets( null )?.val() ?? {} ) as Record< string, string >
			if( next === undefined ) return links[ name ] ?? ''
			this.Col_relation_datasets( null )?.val({ ...links, [ name ]: next })
			return next
		}

		@ $mol_mem_key
		col_relation_display_field( name: string, next?: string ) {
			const fields = ( this.Col_relation_display_fields( null )?.val() ?? {} ) as Record< string, string >
			if( next === undefined ) return fields[ name ] ?? ''
			this.Col_relation_display_fields( null )?.val({ ...fields, [ name ]: next })
			return next
		}

		@ $mol_mem_key
		col_select_options( name: string, next?: readonly string[] ) {
			const all = ( this.Col_select_options()?.val() ?? {} ) as Record< string, string[] >
			if( next === undefined ) return all[ name ] ?? []
			this.Col_select_options( null )!.val({ ...all, [ name ]: [ ...next ] })
			return [ ...next ]
		}

		@ $mol_mem
		cols_hidden( next?: readonly string[] ): readonly string[] {
			return ( this.Cols_hidden( next )?.val( next ) as readonly string[] | undefined )
				?? ( this.Dataset()?.remote() ? $shm_hitalama_map_widget_entity_table2_dataset.system_names : [] )
		}

		@ $mol_mem
		cols_order( next?: readonly string[] ): readonly string[] {
			return ( this.Cols_order( next )?.val( next ) as readonly string[] | undefined ) ?? []
		}

		@ $mol_mem
		cols_pinned( next?: readonly string[] ): readonly string[] {
			return ( this.Cols_pinned( next )?.val( next ) as readonly string[] | undefined ) ?? []
		}

		@ $mol_mem
		head_computeds(): { title: string, calc: ( row: any[] )=> any }[] {
			return []
		}

		@ $mol_mem
		head_extended() {
			return [ ...this.table_head() ?? [], ...this.head_computeds().map( h => h.title ) ]
		}

		@ $mol_mem
		rows_extended() {
			const head_calculated = this.head_computeds()
			const rows = this.table_rows()
			return rows?.map( ( row: any ) => {
				const calculated = head_calculated.map( ({ calc })=> {
					return calc( row )
				} )
				return [ ...row, ...calculated ]
			} )
		}

	}

}
